import apiFetch from '../apiFetch'

export default function (code, token) {
  return apiFetch({ endPoint: `DocumentByCode?code=${code}`, method: 'GET', token: token })
}
